import type { Product } from '../types';

const rawProducts = [
  {
    id: 'prod-001',
    name: 'سيروم فيتامين سي المضيء',
    category: 'العناية بالبشرة',
    price: 189,
    oldPrice: 250,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20vitamin%20C%20serum%20bottle%20on%20soft%20beige%20marble%20surface%20with%20rose%20petals%20and%20golden%20light%20elegant%20beauty%20product%20photography%20minimal%20clean%20aesthetic%20warm%20tones&width=600&height=800&seq=101&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20vitamin%20C%20serum%20bottle%20on%20soft%20beige%20marble%20surface%20with%20rose%20petals%20and%20golden%20light%20elegant%20beauty%20product%20photography%20minimal%20clean%20aesthetic%20warm%20tones&width=600&height=800&seq=101&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Woman%20applying%20vitamin%20C%20serum%20to%20her%20face%20in%20soft%20natural%20light%20elegant%20beauty%20routine%20skincare%20minimal%20warm%20beige%20background&width=600&height=800&seq=102&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Vitamin%20C%20serum%20texture%20close%20up%20dropper%20golden%20liquid%20on%20glass%20elegant%20beauty%20product%20photography%20warm%20soft%20light&width=600&height=800&seq=103&orientation=portrait',
    ],
    rating: 4.8,
    reviewCount: 124,
    badge: 'الأكثر مبيعًا',
    description: 'سيروم فيتامين سي المركز بتركيبة متقدمة لتفتيح البشرة وتقليل ظهور البقع الداكنة. يحتوي على 20% فيتامين سي النقي مع حمض الهيالورونيك للترطيب العميق.',
    benefits: ['تفتيح البشرة', 'تقليل البقع الداكنة', 'ترطيب عميق', 'مكافحة علامات التقدم بالعمر'],
    ingredients: 'ماء مقطر، فيتامين سي (أسكوربيك حمض)، حمض الهيالورونيك، نياسيناميد، فيتامين E، مستخلص الشاي الأخضر، غليسيرين طبيعي.',
    howToUse: 'ضعي 3-4 قطرات على الوجه النظيف صباحاً ومساءً قبل المرطب. دلكي بلطف بحركات دائرية صاعدة.',
    inStock: true,
    sku: 'SAH-VC-001',
  },
  {
    id: 'prod-002',
    name: 'كريم الليل المجدد',
    category: 'العناية بالبشرة',
    price: 245,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20night%20cream%20jar%20in%20soft%20pink%20and%20beige%20setting%20with%20silk%20fabric%20and%20pearl%20elegant%20beauty%20product%20photography%20warm%20tones%20minimal%20aesthetic&width=600&height=800&seq=201&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20night%20cream%20jar%20in%20soft%20pink%20and%20beige%20setting%20with%20silk%20fabric%20and%20pearl%20elegant%20beauty%20product%20photography%20warm%20tones%20minimal%20aesthetic&width=600&height=800&seq=201&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Woman%20sleeping%20peacefully%20on%20silk%20pillowcase%20with%20night%20skincare%20routine%20soft%20warm%20light%20elegant%20beauty%20lifestyle%20photography&width=600&height=800&seq=202&orientation=portrait',
    ],
    rating: 4.9,
    reviewCount: 89,
    badge: 'الأكثر مبيعًا',
    description: 'كريم الليل المجدد بتركيبة غنية يعمل أثناء نومك لإصلاح البشرة واستعادة نضارتها. يحتوي على الببتيدات وحمض الهيالورونيك.',
    benefits: ['تجديد خلايا البشرة', 'ترطيب لمدة 24 ساعة', 'تقليل التجاعيد الدقيقة', 'استعادة النضارة'],
    ingredients: 'ماء، بترولاتوم، جليسيرين، زبدة الشيا، ببتيدات النحاس، حمض الهيالورونيك، فيتامين E، زيت الأرجان.',
    howToUse: 'ضعي طبقة رقيقة على الوجه والرقبة بعد التنظيف مساءً. اتركيه طوال الليل.',
    inStock: true,
    sku: 'SAH-NC-002',
  },
  {
    id: 'prod-003',
    name: 'زيت الجسم الفاخر',
    category: 'العناية بالجسم',
    price: 165,
    oldPrice: 200,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20body%20oil%20bottle%20with%20gold%20dropper%20on%20marble%20surface%20surrounded%20by%20dried%20flowers%20elegant%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=301&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20body%20oil%20bottle%20with%20gold%20dropper%20on%20marble%20surface%20surrounded%20by%20dried%20flowers%20elegant%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=301&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Woman%20massaging%20body%20oil%20on%20her%20arms%20soft%20skin%20care%20routine%20warm%20elegant%20bathroom%20setting%20natural%20light%20beauty%20lifestyle&width=600&height=800&seq=302&orientation=portrait',
    ],
    rating: 4.7,
    reviewCount: 67,
    badge: 'جديد',
    description: 'زيت الجسم الفاخر بمزيج من زيوت الأرغان والورد والجوجوبا العضوية. يترك بشرتك ناعمة كالحرير مع رائحة زهرية دافئة.',
    benefits: ['ترطيب عميق للجسم', 'ملمس حريري', 'رائحة فاخرة تدوم', 'مكونات عضوية طبيعية'],
    ingredients: 'زيت الأرغان العضوي، زيت الورد، زيت الجوجوبا، زيت اللوز الحلو، فيتامين E، مستخلص الياسمين.',
    howToUse: 'دلكي البشرة المبللة بعد الاستحمام بحركات دائرية. أو أضيفي قطرات إلى حوض الاستحمام.',
    inStock: true,
    sku: 'SAH-BO-003',
  },
  {
    id: 'prod-004',
    name: 'فرشاة الأساس الاحترافية',
    category: 'أدوات التجميل',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=Professional%20makeup%20foundation%20brush%20with%20rose%20gold%20handle%20on%20soft%20velvet%20surface%20elegant%20beauty%20tool%20photography%20warm%20light%20minimal%20clean%20aesthetic%20beige%20background&width=600&height=800&seq=401&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20makeup%20foundation%20brush%20with%20rose%20gold%20handle%20on%20soft%20velvet%20surface%20elegant%20beauty%20tool%20photography%20warm%20light%20minimal%20clean%20aesthetic%20beige%20background&width=600&height=800&seq=401&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Set%20of%20luxury%20makeup%20brushes%20with%20rose%20gold%20handles%20arranged%20on%20marble%20surface%20elegant%20beauty%20tools%20photography%20warm%20soft%20light&width=600&height=800&seq=402&orientation=portrait',
    ],
    rating: 4.6,
    reviewCount: 156,
    description: 'فرشاة أساس احترافية بشعيرات صناعية ناعمة كالحرير. مقبض روز ذهبي فاخر لتوزيع الأساس بشكل مثالي.',
    benefits: ['توزيع متساوٍ للأساس', 'شعيرات ناعمة', 'سهلة التنظيف', 'مقبض فاخر'],
    ingredients: 'شعيرات صناعية ناعمة، مقبض روز ذهبي مطلي، تصميم مريح لليد.',
    howToUse: 'ضعي كمية صغيرة من الأساس على ظهر يدك. استخدمي الفرشاة بحركات دائرية صاعدة.',
    inStock: true,
    sku: 'SAH-MB-004',
  },
  {
    id: 'prod-005',
    name: 'قناع الطين المغربي',
    category: 'العناية بالبشرة',
    price: 135,
    image: 'https://readdy.ai/api/search-image?query=Moroccan%20clay%20mask%20in%20earthenware%20bowl%20with%20wooden%20spoon%20and%20dried%20herbs%20elegant%20skincare%20product%20photography%20warm%20earth%20tones%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=501&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Moroccan%20clay%20mask%20in%20earthenware%20bowl%20with%20wooden%20spoon%20and%20dried%20herbs%20elegant%20skincare%20product%20photography%20warm%20earth%20tones%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=501&orientation=portrait',
    ],
    rating: 4.5,
    reviewCount: 43,
    description: 'قناع الطين المغربي الأصيل لتنقية البشرة العميقة. يستخرج من جبال الأطلس مع مستخلصات الأعشاب الطبيعية.',
    benefits: ['تنقية عميقة للمسام', 'إزالة الخلايا الميتة', 'توازن إفراز الزيوت', 'تجديد البشرة'],
    ingredients: 'طين غاسول مغربي، زيت الأرغان، مستخلصات الخزامى والنعناع، ماء الورد.',
    howToUse: 'اخلطي مع ماء الورد حتى تتكون عجينة ناعمة. ضعي على الوجه لمدة 10-15 دقيقة ثم اشطفي.',
    inStock: true,
    sku: 'SAH-CM-005',
  },
  {
    id: 'prod-006',
    name: 'مجموعة العناية اليومية',
    category: 'العناية بالبشرة',
    price: 450,
    oldPrice: 580,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20skincare%20gift%20set%20with%20three%20bottles%20in%20elegant%20box%20silk%20ribbon%20beige%20and%20gold%20packaging%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=601&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20skincare%20gift%20set%20with%20three%20bottles%20in%20elegant%20box%20silk%20ribbon%20beige%20and%20gold%20packaging%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=601&orientation=portrait',
    ],
    rating: 4.9,
    reviewCount: 210,
    badge: 'مجموعة مميزة',
    description: 'مجموعة العناية اليومية الكاملة: منظف، تونر، ومرطب. العناية المثالية في ثلاث خطوات سهلة.',
    benefits: ['نظافة عميقة', 'توازن البشرة', 'ترطيب يومي', 'قيمة ممتازة'],
    ingredients: 'تتضمن منظف بالشاي الأخضر، تونر بالورد، ومرطب بالهيالورونيك.',
    howToUse: 'استخدمي المنظف صباحاً ومساءً، ثم التونر، وأخيراً المرطب.',
    inStock: true,
    sku: 'SAH-DS-006',
  },
  {
    id: 'prod-007',
    name: 'مقشر الجسم بالسكر والفانيليا',
    category: 'العناية بالجسم',
    price: 110,
    image: 'https://readdy.ai/api/search-image?query=Body%20sugar%20scrub%20in%20glass%20jar%20with%20vanilla%20beans%20and%20brown%20sugar%20elegant%20beauty%20product%20photography%20warm%20tones%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=701&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Body%20sugar%20scrub%20in%20glass%20jar%20with%20vanilla%20beans%20and%20brown%20sugar%20elegant%20beauty%20product%20photography%20warm%20tones%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=701&orientation=portrait',
    ],
    rating: 4.8,
    reviewCount: 78,
    badge: 'جديد',
    description: 'مقشر الجسم الطبيعي بمزيج من السكر البني وزبدة الشيا وزيت الفانيليا. يترك بشرتك ناعمة ولامعة.',
    benefits: ['إزالة الخلايا الميتة', 'تغذية البشرة', 'رائحة فاخرة', 'مكونات طبيعية 100%'],
    ingredients: 'سكر بني، زبدة الشيا، زيت جوز الهند، زيت الفانيليا، فيتامين E.',
    howToUse: 'دلكي على البشرة المبللة بحركات دائرية. اشطفي بالماء الدافئ.',
    inStock: true,
    sku: 'SAH-BS-007',
  },
  {
    id: 'prod-008',
    name: 'بطاقة هدايا - 500 شيكل',
    category: 'بطاقات الهدايا',
    price: 500,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20gold%20gift%20card%20on%20soft%20pink%20velvet%20surface%20with%20pearl%20jewelry%20and%20dried%20flowers%20luxury%20beauty%20gift%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=801&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Elegant%20gold%20gift%20card%20on%20soft%20pink%20velvet%20surface%20with%20pearl%20jewelry%20and%20dried%20flowers%20luxury%20beauty%20gift%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=801&orientation=portrait',
    ],
    rating: 5.0,
    reviewCount: 32,
    badge: 'هدية مثالية',
    description: 'بطاقة هدايا إلكترونية بقيمة 500 شيكل. الهدية المثالية لمحبات الجمال في كل مناسبة.',
    benefits: ['صالحة لمدة سنة', 'قابلة للاستخدام على كل المنتجات', 'تسليم فوري بالبريد', 'تغليف فاخر'],
    ingredients: '',
    howToUse: 'يتم إرسال رمز البطاقة إلى البريد الإلكتروني المحدد فور الشراء.',
    inStock: true,
    sku: 'SAH-GC-500',
  },
  {
    id: 'prod-009',
    name: 'أحمر الشفاه المخملي',
    category: 'أدوات التجميل',
    price: 145,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20velvet%20lipstick%20in%20rose%20gold%20tube%20on%20marble%20surface%20with%20swatch%20of%20deep%20berry%20color%20elegant%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=901&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20velvet%20lipstick%20in%20rose%20gold%20tube%20on%20marble%20surface%20with%20swatch%20of%20deep%20berry%20color%20elegant%20beauty%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic&width=600&height=800&seq=901&orientation=portrait',
    ],
    rating: 4.7,
    reviewCount: 198,
    description: 'أحمر شفاه مخملي بتركيبة طويلة الأمد. لون غني وتغطية كاملة مع ملمس ناعم كالمخمل.',
    benefits: ['ملمس مخملي فاخر', 'ثبات لمدة 8 ساعات', 'ترطيب الشفاه', 'ألوان غنية'],
    ingredients: 'شمع العسل، زيت الجوجوبا، فيتامين E، صبغات طبيعية، زبدة الشيا.',
    howToUse: 'حددي محيط الشفاه ثم املئي من المركز إلى الخارج.',
    inStock: true,
    sku: 'SAH-LS-009',
    variants: [
      { id: 'var-001', name: 'وردي بلاش', price: 145 },
      { id: 'var-002', name: 'توتي داكن', price: 145 },
      { id: 'var-003', name: 'أحمر كلاسيكي', price: 145 },
    ],
  },
  {
    id: 'prod-010',
    name: 'تونر الورد المنعش',
    category: 'العناية بالبشرة',
    price: 120,
    image: 'https://readdy.ai/api/search-image?query=Rose%20water%20toner%20in%20clear%20glass%20bottle%20with%20rose%20petals%20floating%20elegant%20skincare%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1001&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Rose%20water%20toner%20in%20clear%20glass%20bottle%20with%20rose%20petals%20floating%20elegant%20skincare%20product%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1001&orientation=portrait',
    ],
    rating: 4.6,
    reviewCount: 95,
    description: 'تونر الورد الطبيعي 100% يهدئ وينعش البشرة. مستخرج من ورد دمشقي عضوي.',
    benefits: ['تهدئة البشرة', 'إغلاق المسام', 'إنعاش فوري', 'ماء ورد طبيعي'],
    ingredients: 'ماء ورد دمشقي عضوي 100%، مستخلص الألوفيرا، غليسيرين طبيعي.',
    howToUse: 'رشي على الوجه بعد التنظيف أو استخدمي قطنة لتنظيف البشرة.',
    inStock: true,
    sku: 'SAH-RT-010',
  },
  {
    id: 'prod-011',
    name: 'بطاقة هدايا - 200 شيكل',
    category: 'بطاقات الهدايا',
    price: 200,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20beauty%20gift%20card%20with%20floral%20design%20on%20cream%20paper%20with%20gold%20foil%20accents%20luxury%20packaging%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1101&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Elegant%20beauty%20gift%20card%20with%20floral%20design%20on%20cream%20paper%20with%20gold%20foil%20accents%20luxury%20packaging%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1101&orientation=portrait',
    ],
    rating: 5.0,
    reviewCount: 28,
    description: 'بطاقة هدايا إلكترونية بقيمة 200 شيكل. هدية لطيفة لكل مناسبة.',
    benefits: ['صالحة لمدة سنة', 'قابلة للاستخدام على كل المنتجات', 'تسليم فوري', 'تصميم أنيق'],
    ingredients: '',
    howToUse: 'يتم إرسال رمز البطاقة إلى البريد الإلكتروني المحدد فور الشراء.',
    inStock: true,
    sku: 'SAH-GC-200',
  },
  {
    id: 'prod-012',
    name: 'مجموعة فرش التجميل الاحترافية',
    category: 'أدوات التجميل',
    price: 320,
    oldPrice: 420,
    image: 'https://readdy.ai/api/search-image?query=Professional%20makeup%20brush%20set%20in%20leather%20case%20with%20rose%20gold%20handles%20elegant%20beauty%20tools%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1201&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20makeup%20brush%20set%20in%20leather%20case%20with%20rose%20gold%20handles%20elegant%20beauty%20tools%20photography%20warm%20soft%20light%20minimal%20aesthetic%20beige%20background&width=600&height=800&seq=1201&orientation=portrait',
    ],
    rating: 4.8,
    reviewCount: 134,
    badge: 'الأكثر مبيعًا',
    description: 'مجموعة 10 فرش تجميل احترافية بمقابض روز ذهبية فاخرة. تشمل كل ما تحتاجه لإطلالة كاملة.',
    benefits: ['10 فرش متخصصة', 'شعيرات ناعمة كالحرير', 'مقبض فاخر', 'علبة جلد أنيقة'],
    ingredients: 'شعيرات صناعية ناعمة، مقابض مطلية بالروز الذهبي.',
    howToUse: 'استخدمي كل فرشاة لغرضها المخصص. نظفي أسبوعياً بمنظف الفرش.',
    inStock: true,
    sku: 'SAH-BS-012',
  },
];

export const products: Product[] = rawProducts.map((p) => ({
  ...p,
  slug: `product-${p.id}`,
  stockQuantity: 10,
}));

export const featuredProducts = products.filter(p => p.badge === 'الأكثر مبيعًا');
export const newArrivals = products.filter(p => p.badge === 'جديد');
export const giftCards = products.filter(p => p.category === 'بطاقات الهدايا');
export const skincareSets = products.filter(p => p.category === 'العناية بالبشرة');

export const getProductById = (id: string): Product | undefined => {
  return products.find(p => p.id === id);
};

export const getRelatedProducts = (productId: string, limit: number = 4): Product[] => {
  const product = getProductById(productId);
  if (!product) return [];
  return products
    .filter(p => p.id !== productId && p.category === product.category)
    .slice(0, limit);
};